import React from 'react';
import { Dayjs } from 'dayjs';

import { ModalComponent } from 'baseComponents/ModalComponent';

// Helpers
import { disabledDate, disabledTime } from 'helpers/scheduling-options';
import { ButtonComponent } from 'baseComponents/ButtonComponent';
import './removeCampaignModal.scss';
import { DatePickerComponent } from 'baseComponents/DatePickerComponent';
import { TimePickerComponent } from 'baseComponents/TimePickerComponent';

interface Props {
  isModalOpen: boolean;
  closeModal: () => void;
  handleDeleteCampaign: () => void;
  date: Dayjs | null;
  time: Dayjs | null;
  setDate: (date: Dayjs | null) => void;
  setTime: (time: Dayjs | null) => void;
}

export const EditCampaignModal: React.FC<Props> = (props) => {
  return (
    <ModalComponent
      title='Reschedule campagin'
      close={props.closeModal}
      open={props.isModalOpen}
    >
      <div className='picker-wrapper'>
        <DatePickerComponent
          disabledDate={disabledDate}
          value={props.date}
          onChange={(date: Dayjs | null) => props.setDate(date)}
        />
      </div>
      <div className='picker-wrapper'>
        <TimePickerComponent
          disabledTime={disabledTime}
          value={props.time}
          onChange={(time: Dayjs | null) => {
            return props.setTime(time);
          }}
        />
      </div>
      <div className='remove-campaign-btns'>
        <ButtonComponent
          appereance='primary'
          size='middle'
          onClick={props.handleDeleteCampaign}
          label='Edit campaign'
          fullWidth
          disabled={!props.date || !props.time}
        />
        <ButtonComponent
          appereance='secondary'
          size='middle'
          onClick={props.closeModal}
          label='Cancel'
          fullWidth
        />
      </div>
    </ModalComponent>
  );
};
